import { H4, H5, Image, LI, UL } from "../../../../../AbstractElements";
import { Href } from "../../../../../Constants/Constants";
import { StepperHorizontalData } from "../../../../../Data/Pages/Pages";
import { RegisterWizardProp } from "../../../../../Types/OthersType";
import { dynamicImage } from "../../../../../Utils";
import CommonLogo from "../Common/CommonLogo";

const RegisterWizardList: React.FC<RegisterWizardProp> = ({ level }) => {
  return (
    <UL className="simple-list anchor">
      <LI>
        <CommonLogo logoClass="ps-0" />
      </LI>
      {StepperHorizontalData.map((item) => (
        <LI key={item.id}>
          <a href={Href} className={`${level === item.id ? "selected" : level > item.id ? "done" : "disabled"}`}>
            <H4>{item.id}</H4>
            <H5>{item.title}{item.icon}</H5>
            <small>{item.detail}</small>
          </a>
        </LI>
      ))}
      <LI>
        <Image className="img-fluid w-100" src={dynamicImage(`login/icon.png`)} alt="loogin page" />
      </LI>
    </UL>
  );
};
export default RegisterWizardList;
